var AppEvent = /** @class */ (function () {
    function AppEvent() {
        this.listeners = new Set();
    }
    AppEvent.prototype.subscribe = function (listener) {
        this.listeners.add(listener);
    };
    AppEvent.prototype.unsubscribe = function (listener) {
        this.listeners.delete(listener);
    };
    AppEvent.prototype._fire = function (args) {
        for (var _i = 0, _a = Array.from(this.listeners.keys()); _i < _a.length; _i++) {
            var listener = _a[_i];
            listener(args);
        }
    };
    return AppEvent;
}());
export default AppEvent;



//////////////////
// WEBPACK FOOTER
// ./src/models/AppEvent.ts
// module id = 69
// module chunks = 0